import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

export default function Footer(){
    return (
        <footer>
        <p>Carefully Curated Content | Protected by Charms</p>
    </footer>  
    );
};